import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-bpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-bpams.component.scss?ngResource";
import { Component } from "@angular/core";
import { ViewApplicationDetailsBpamsConstants } from "./view-application-details-bpams.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { CreateApplicationDetailsBpamsConstants } from "../../../../create-application/modules/bp/create-application-details-bpams/create-application-details-bpams.constants";
import { AppControllerService } from "../../../../app-controller.service";
let ViewApplicationDetailsBpamsComponent = class ViewApplicationDetailsBpamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    routerParamsService;
    appController;
    detailsForm;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    descriptionFormControlName = ViewApplicationDetailsBpamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    descriptionLabel = ViewApplicationDetailsBpamsConstants.DESCRIPTION_LABEL;
    isMinorBuildingWorkLabel = ViewApplicationDetailsBpamsConstants.IS_MINOR_BUILDING_WORK_LABEL;
    sectorLabel = ViewApplicationDetailsBpamsConstants.SECTOR_LABEL;
    isRdpLabel = ViewApplicationDetailsBpamsConstants.IS_RDP_LABEL;
    buildingUseLabel = ViewApplicationDetailsBpamsConstants.BUILDING_USE_LABEL;
    otherBuildingUseLabel = CreateApplicationDetailsBpamsConstants.OTHER_BUILDING_USE_LABEL;
    isAlterationsLabel = CreateApplicationDetailsBpamsConstants.IS_ALTERATIONS_LABEL;
    isResidentialApplicationLabel = CreateApplicationDetailsBpamsConstants.IS_RESIDENTIAL_APPLICATION_LABEL;
    typeLabel = ViewApplicationDetailsBpamsConstants.APPLICATION_TYPE_LABEL;
    estimatedByLabel = ViewApplicationDetailsBpamsConstants.APPLICATION_ESTIMATED_BY_LABEL;
    estimatedCostLabel = ViewApplicationDetailsBpamsConstants.APPLICATION_ESTIMATED_COST_LABEL;
    previousReferenceNumberLabel = ViewApplicationDetailsBpamsConstants.PREVIOUS_REFERENCE_NUMBER_LABEL;
    isExtensionLabel = ViewApplicationDetailsBpamsConstants.IS_EXTENSION_LABEL;
    isResubmissionLabel = ViewApplicationDetailsBpamsConstants.IS_RESUBMISSION_LABEL;
    isMinorBuildingWorkFormControlName = ViewApplicationDetailsBpamsConstants.IS_MINOR_BUILDING_WORK_FORM_CONTROL_NAME;
    sectorFormControlName = ViewApplicationDetailsBpamsConstants.SECTOR_FORM_CONTROL_NAME;
    isRdpFormControlName = ViewApplicationDetailsBpamsConstants.IS_RDP_FORM_CONTROL_NAME;
    buildingUseFormControlName = ViewApplicationDetailsBpamsConstants.BUILDING_USE_FORM_CONTROL_NAME;
    isAlterationsFormControlName = CreateApplicationDetailsBpamsConstants.IS_ALTERATIONS_CONTROL_NAME;
    isResidentialApplicationFormControlName = CreateApplicationDetailsBpamsConstants.IS_RESIDENTIAL_APPLICATION_CONTROL_NAME;
    buildingTypeFormControlName = CreateApplicationDetailsBpamsConstants.BUILDING_TYPE_CONTROL_NAME;
    typeFormControlName = ViewApplicationDetailsBpamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    estimatedByFormControlName = ViewApplicationDetailsBpamsConstants.APPLICATION_ESTIMATED_BY_FORM_CONTROL_NAME;
    estimatedCostFormControlName = ViewApplicationDetailsBpamsConstants.APPLICATION_ESTIMATED_COST_FORM_CONTROL_NAME;
    previousReferenceNumberFormControlName = ViewApplicationDetailsBpamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    isExtensionFormControlName = ViewApplicationDetailsBpamsConstants.IS_EXTENSION_FORM_CONTROL_NAME;
    isResubmissionFormControlName = ViewApplicationDetailsBpamsConstants.IS_RESUBMISSION_FORM_CONTROL_NAME;
    application;
    selectedApplicationSubscription;
    startMetadataSubscription;
    supportResubmissions = false;
    supportExtensions = false;
    isResubmission = false;
    isExtension = false;
    showBuildingTypeField = true;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService, appController) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.routerParamsService = routerParamsService;
        this.appController = appController;
    }
    ngOnInit() {
        this.getMetadata();
        this.initForm();
        this.subscribeToSelectedApplication();
        this.listenForRouteParamChange();
        if (this.appController.moduleAllowResubmission) {
            this.supportResubmissions = true;
        }
    }
    handleRouteChange() {
    }
    loadMetadata(stepMeta) {
        if (stepMeta.extensionOptions !== undefined && stepMeta.extensionOptions !== null) {
            this.supportExtensions = stepMeta.extensionOptions.enabled;
        }
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        this.detailsForm.get(this.descriptionFormControlName).disable();
        this.detailsForm.get(this.isMinorBuildingWorkFormControlName).setValue(application.isMinorBuildingWork);
        this.detailsForm.get(this.isMinorBuildingWorkFormControlName).disable();
        this.detailsForm.get(this.sectorFormControlName).setValue(application.sector);
        this.detailsForm.get(this.sectorFormControlName).disable();
        this.detailsForm.get(this.isRdpFormControlName).setValue(application.isRdp);
        this.detailsForm.get(this.isRdpFormControlName).disable();
        this.detailsForm.get(this.buildingUseFormControlName).setValue(application.buildingUse);
        this.detailsForm.get(this.buildingUseFormControlName).disable();
        this.detailsForm.get(this.buildingTypeFormControlName).setValue(application.buildingType);
        this.detailsForm.get(this.buildingTypeFormControlName).disable();
        this.detailsForm.get(this.isAlterationsFormControlName).setValue(application.isAlterations);
        this.detailsForm.get(this.isAlterationsFormControlName).disable();
        this.detailsForm.get(this.isResidentialApplicationFormControlName).setValue(application.isResidential);
        this.detailsForm.get(this.isResidentialApplicationFormControlName).disable();
        this.detailsForm.get(this.typeFormControlName).setValue(application.applicationType);
        this.detailsForm.get(this.typeFormControlName).disable();
        this.detailsForm.get(this.estimatedByFormControlName).setValue(application.applicationEstimatedBy);
        this.detailsForm.get(this.estimatedByFormControlName).disable();
        this.detailsForm.get(this.estimatedCostFormControlName).setValue(application.applicationEstimatedCost);
        this.detailsForm.get(this.estimatedCostFormControlName).disable();
        this.detailsForm.get(this.isExtensionFormControlName).setValue(application.isExtension);
        this.detailsForm.get(this.isExtensionFormControlName).disable();
        this.detailsForm.get(this.isResubmissionFormControlName).setValue(application.isResubmission);
        this.detailsForm.get(this.isResubmissionFormControlName).disable();
        this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(application.previousReferenceNumber);
        this.detailsForm.get(this.previousReferenceNumberFormControlName).disable();
        if (application.isResubmission) {
            this.isResubmission = application.isResubmission;
        }
        if (application.isExtension) {
            this.isExtension = application.isExtension;
        }
        if (application.isBuildingUseOther) {
            this.showBuildingTypeField = true;
        }
        else {
            this.showBuildingTypeField = false;
        }
    }
    getMetadata() {
        this.startMetadataSubscription = this.applicationViewService.$startMetadata.subscribe(stepMeta => {
            if (stepMeta !== null) {
                this.stepMeta = stepMeta;
                this.loadMetadata(this.stepMeta);
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: RouterParamsService },
        { type: AppControllerService }
    ];
};
ViewApplicationDetailsBpamsComponent = __decorate([
    Component({
        selector: "app-view-application-details-bpams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsBpamsComponent);
export { ViewApplicationDetailsBpamsComponent };
